export default __webpack_public_path__ + "static/media/wormhole-network.5bb90ed1.svg";